import type React from 'react';

import { StaffDrawer, StaffDrawerInfo, StaffDrawerLink, StaffDrawerSection } from '#src/app/shared/components/staff';

import { useDmProfileStaffDrawer } from './hooks/useDmProfileStaffDrawer';

export const DmProfileStaffDrawer: React.FC<EmptyProps> = () => {
	const {
		data: { dmId, slug, slugCopyable, type, publiclyVisible, verified, location, urls, responsiveness, enrichedData },
	} = useDmProfileStaffDrawer();

	return (
		<StaffDrawer>
			<StaffDrawerSection title="Decision maker">
				<StaffDrawerInfo label="DM ID" value={dmId} copyable />
				<StaffDrawerInfo label="Slug" value={slug} copyable={slugCopyable} />
				<StaffDrawerInfo label="Type" value={type} />
				<StaffDrawerInfo label="Publicly visible" value={publiclyVisible} />
				<StaffDrawerInfo label="Verified" value={verified} />
				<StaffDrawerInfo label="Location" value={location} />
				<StaffDrawerLink href={urls.dmAdmin}>DM admin</StaffDrawerLink>
				<StaffDrawerLink href={urls.edit}>Edit</StaffDrawerLink>
				<StaffDrawerLink href={urls.adminAccounts}>Admin accounts</StaffDrawerLink>
			</StaffDrawerSection>
			{responsiveness && (
				<StaffDrawerSection title="Responsiveness">
					<StaffDrawerInfo label="Score" value={responsiveness.score} />
					{responsiveness.respondedRelevant !== undefined && (
						<StaffDrawerInfo label="Responded / relevant petitions" value={responsiveness.respondedRelevant} />
					)}
					<StaffDrawerInfo label="Score visible" value={responsiveness.visible} />
				</StaffDrawerSection>
			)}
			<StaffDrawerSection title="Enriched data">
				<StaffDrawerInfo label="Present" value={enrichedData.present} />
				{enrichedData.endorsementCount !== undefined && (
					<StaffDrawerInfo label="Endorsement count" value={enrichedData.endorsementCount} />
				)}
				{enrichedData.voterGuidePickCount !== undefined && (
					<StaffDrawerInfo label="Voter-guide pick count" value={enrichedData.voterGuidePickCount} />
				)}
			</StaffDrawerSection>
		</StaffDrawer>
	);
};
